module.exports = __webpack_public_path__ + "img/whathot_bg.1326aa71.png";